import { VueModule } from '@Foundation/utilities';
import jumpTo from './code/Scripts/components/jump-to';

export default VueModule({
  components: {
    jumpTo
  }
});
